import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Navigation } from './enums/navigation.enum';
import { EntriesComponent } from './views/entries/entries.component';
import { EntryComponent } from './views/entries/entry/entry.component';
import { EventComponent } from './views/events/event/event.component';
import { EventsComponent } from './views/events/events.component';
import { RaceComponent } from './views/races/race/race.component';
import { RacesComponent } from './views/races/races.component';

const routes: Routes = [
  { path: Navigation.Races.toString(), component: RacesComponent },
  { path: Navigation.RaceDetail + '/:id', component: RaceComponent },
  { path: Navigation.Events.toString(), component: EventsComponent },
  { path: Navigation.EventDetail + '/:id', component: EventComponent },
  { path: Navigation.Entries.toString(), component: EntriesComponent },
  { path: Navigation.EntryDetail + '/:id', component: EntryComponent },

  { path: '', pathMatch: 'full', redirectTo: '/'+Navigation.Races}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
